<template>
  <fragment>
    <v-row class="basic-info">
      <v-col
        v-if="selectedCaseTypesAttachmentType.downloadBase64"
        cols="5"
      >
        <h3 class="attachment-info">
          {{ local.attachments.sampleImage }}
        </h3>
        <div class="sample-image">
          <img
            class="sample-image"
            :src="`data:image/png;base64,${selectedCaseTypesAttachmentType.downloadBase64}`"
          >
        </div>
      </v-col>

      <v-col
        v-if="selectedCaseTypesAttachmentType.description"
        cols="7"
      >
        <h3 class="attachment-info">
          {{ local.attachments.description }}
        </h3>
        <div class="description">
          {{ selectedCaseTypesAttachmentType.description }}
        </div>
      </v-col>
    </v-row>

    <v-row class="actions-wrapper">
      <v-col
        class="actions"
        cols="6"
      >
        <naj-button
          class="add-attachment"
          outlined
          @click="showAttachmentModal()"
        >
          {{ local.attachments.add }}
        </naj-button>
      </v-col>
    </v-row>
  </fragment>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('LawsuitModule');

export default {
  name: 'AttachmentDetailsPanel',
  props: {
    attachmentTypeId: {
      type: Number,
      required: false,
      default: -1,
    },
  },
  computed: {
    ...mapState({ attachmentTypes: state => state.lawsuitRequest.attachmentTypes }),
    selectedCaseTypesAttachmentType() {
      return this.attachmentTypes.find(a => a.id == this.attachmentTypeId) || {};
    },
  },
  methods: {
    showAttachmentModal() {
      this.$emit('show-attachment-modal');
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-info{
    min-height: 300px;
    .attachment-info {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
    color: #484952
    }

    .sample-image{
      width: 100%;
      height: 230px;
    }

    .description{
        color: #75D6CE;
        text-align: right;
        font-size: 20px;
    }
}

.actions-wrapper{
    justify-content: flex-end;
    .actions{
        display: flex;
        justify-content: flex-end;
    }
}
</style>
